export const contentTableConfig = {
  title: '主体列表',
  propList: [
    {prop: 'corpId', label: '主体ID', minWidth: '120'},
    {prop: 'corpName', label: '主体名称', minWidth: '80'},
    {prop: 'belongMonth', label: '所属月份', minWidth: '80'},
    {prop: 'dealCustomer', label: '成交客户数量', minWidth: '80', sortable: 'custom'},
    {prop: 'deleteCustomerCount', label: '删除客户数量', minWidth: '80', sortable: 'custom'},
    {prop: 'joinGroupCount', label: '进主体数量', minWidth: '80', sortable: 'custom'},
    {prop: 'joinGroupRate', label: '进主体占比', minWidth: '80'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
